interface ProcedureMethodExecutionInstance {
  procedureRunConditionReplicate: {replicateNumber: number};
}

export default function getProcedureReplicateName(
  procedureMethodExecutionInstance: ProcedureMethodExecutionInstance
): string {
  return `Replicate ${procedureMethodExecutionInstance.procedureRunConditionReplicate.replicateNumber}`;
}
